import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {ROUTE_NAMES} from "../../../core/consts";
import {computed} from 'mobx';
import {AppTerms} from "../../../core/app/app-terms";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {BaseModel} from "../../../infrastructure/models/base-model";

export class BaseHeaderViewModel extends BaseModel {
  terms: AppTerms;
  navigationManager: NavigationManager;
  entity: EntityViewModel;
  isSmallView: Boolean;

  constructor(terms: AppTerms, navigationManager: NavigationManager, entity: EntityViewModel, isSmallView: Boolean) {
    super(entity);

    this.terms = terms;
    this.navigationManager = navigationManager;
    this.entity = entity;
    this.isSmallView = isSmallView;
  }

  @computed get currentLinkModel(): BaseLinkModel {
    return this.navigationManager.currentLinkModel;
  }

  get id() {
    return this.entity.id;
  }

  get objectType() {
    return this.entity.objectType;
  }

  get linkModel() {
    return this.entity.linkModel;
  }

  get headerLabel() {
    return this.entity.longName || this.entity.name;
  }

  get entityNameMobile() {
    return this.entity.shortName || this.entity.name;
  }

  get breadcrumbs() {
    return `${this.entity.sportName} / ${this.entity.countryName} / ${this.entity.name}`;
  }

  get country() {
    return this.entity.countryName;
  }

  get links() {
    throw new Error('links not implemented')
  }

  get shouldRenderTabs(): Boolean {
    const isDisplayTabsRoutes: Boolean = [ROUTE_NAMES.allScoresPage, ROUTE_NAMES.myScoresPage].includes(this.currentLinkModel?.name);

    const hasLinks: Boolean = this.links.length > 1;

    const shouldRenderTabs: Boolean = isDisplayTabsRoutes && hasLinks;

    return shouldRenderTabs;
  }

  get activeLink() {
    return this.links?.find((tab) => tab.active)?.linkModel;
  }
}
